import React from 'react';
import { RouteEnum } from 'pro/config/routers';
import { isPhone } from 'base/utils/client';
import { Logo, ILogoProps } from '@base/common/Logo';

export type ISiteLogoProps = Omit<ILogoProps, 'typeMap' | 'width' | 'height'>;

export const logoTypeMap = {
    default: 'file-asset/file/c37e878ed5fb01172b4892be9b02bb1a.svg',
    light: 'file-asset/file/7490b5b9abfb76d10b87432027857a1f.svg',
    primary: 'file-asset/file/5411855e90eccafd2d844ce75bbdaeae.svg',
    sample: 'file-asset/file/8a8f57061a3aefd8fa85b96bab167439.svg'
};

export const SiteLogo: React.FC<ISiteLogoProps> = (props) => {
    const {
        type = 'default',
        size = isPhone ? 123 : 180,
        href = RouteEnum.SHOP,
        ...rest
    } = props

    return (
        <Logo
            typeMap={logoTypeMap}
            width={180}
            height={33}
            type={type}
            size={size}
            href={href}
            {...rest}
        />
    )
};

export default SiteLogo;